import React from 'react';

import Right from "./Right";
import Panel from "./Panel";

import store from "../store";
import {api, storageName} from "./baseFunctions";
import {Link} from "react-router";
import FormItem from "./FormItem";
import QRCode from 'qrcode';
class Firms extends React.Component {
	constructor(){
		super();
		this.getData = this.getData.bind(this);
		this.getFirm = this.getFirm.bind(this);
		this.formChange = this.formChange.bind(this);
		this.imgChange = this.imgChange.bind(this);
		this.save = this.save.bind(this);
		this.state = {
			data:[],
			firmData: {},
			sheets: [],
			obsSheets: [],
			QRI: 0,
		};
	}
	componentDidMount(){
		this.getData();
		if(this.props.params.id)
		{
			this.getFirm(this.props.params.id);
		}
	}
	imgChange(e)
	{
		var files = e.target.files;
		var reader = [];
		var me = this;
		for(var i = 0; i < files.length; i++)
		{
			reader[i]  = new FileReader();
			reader[i].i = i;
			reader[i].addEventListener("load", function () {
				me.b64Img.value = this.result;
				const DATA = {...me.state.firmData};
				DATA.logo = this.result;
				me.setState({
					firmData: DATA
				});
				console.log("Setting", me.b64Img);
			}, false);
		    reader[i].readAsDataURL(files[i]);
		}
	}
	getFirm(id)
	{
		console.log("GetFirm");
		api("POST", {"type": "getFirmData", id, "sheetContent":true}, (d) => {
      if(!d.error)
      {
	      console.log("FirmData",d);
	      const DATA = {...d.data};
	      if(id === "NEW")
	      {
	      	DATA.mainYellow = "#f8a21c";
	      	DATA.subYellow = "#fbb616";
	      	DATA.darkGrey = "#1f1f1f";
	      	DATA.subGrey = "#1f1f1f";
	      	DATA.listGrey = "#1f1f1f";
	      	DATA.white = "#FFFFFF";
	      	DATA.borderGrey = "#424242";
	      	DATA.modules = [];
	      	for(var i = 0; i < 20; i++)
	      	{
	      		DATA.modules[i] = 0;
	      	}
	      }
	      DATA.obsSheets = [];
	      if(typeof DATA.obsFields === "string")
	      {
	      	 DATA.obsSheets = JSON.parse(DATA.obsFields); 
	      }
	      this.setState({firmData: DATA, obsSheets: d.obsSheets});
      }else if(d.msg){
        alert(d.msg);
      }
    }, this.props.auth);
	}
	formChange(e){
		var target = e.target;
			console.log(target.name, "=", target.value, this.state.firmData, this.props.params.id);
		const firmData = {...this.state.firmData};
		if(this.props.params.id && firmData[target.name] || !this.props.params.id)
		{
			if(target.name === "modules")
			{
				firmData.modules[target.dataset.i] = target.checked ? 1 : 0;
			}else{
				firmData[target.name] = target.value;
			}
			this.setState({firmData});
			console.log(firmData);
		}
	}

	overViewTable; 
	getData(){
		api("POST", {"type": "getFirms"}, (d) => {
			console.log(d);
			if(!d.error)
			{
        //return 1;
				this.setState({
					data: d.data
				});
				if(this.overViewTable)
				{
					this.overViewTable.fnDestroy();
				}
				this.overViewTable = window.$("#ras").dataTable({
            "iDisplayLength": 50,
            "order": [[ 0, "desc" ]],
            "language": {
                "lengthMenu": "Vis _MENU_ pr side",
                "zeroRecords": "Intet fundet",
                "info": "Side _PAGE_ / _PAGES_",
                "infoEmpty": "Intet indhold",
                "search":         "Søg: ",
                 "paginate": {
                    "first":      "Første",
                    "last":       "Sidste",
                    "next":       "Næste",
                    "previous":   "Forrige"
                },
                "infoFiltered": "(filterer fra _MAX_ colonner)"
            }
        });
			}
		}, this.props.auth, 1);
		api("POST", {"type": "getRAsheets"}, (d) => {
			if(!d.error)
			{
				this.setState({sheets: d.data});
			}
		}, this.props.auth);
	}
	save(e){
		e.preventDefault();
		const data = {...this.state.firmData};
		var sheets = [];
		var sheet;
		// var options = this.raSheets.options;
		// for(var i = 0; i < options.length; i++)
		// {
		// 	sheet = options[i];
		// 	if(sheet.selected)
		// 	{
		// 		sheets.push({"id":sheet.value, "name": sheet.dataset.name, "hidden": Number(sheet.dataset.hidden)});
		// 	}
		// }

		var obsSheets = [];
		// var options = this.refs.obsSheets.options;
		// //console.log(options);
		// for(var i = 0; i < options.length; i++)
		// {
		// 	sheet = options[i];
		// 	if(sheet.selected)
		// 	{
		// 		obsSheets.push(sheet.value);
		// 	}
		// }

		// data.obsSheets = obsSheets;
		// data.sheets = sheets;
		// data.obsSheet = this.refs.obsSheet.value;
		//console.log({"type": this.props.location.pathname === "/firms/new" ? "newFirm" : "saveFirm", data});
		//return;
		api("POST", {"type": "saveFirm", data}, (d) => {
			//console.log(d);
			if(!d.error)
			{
				alert("Firmaet er gemt.");
				this.getData();
			}
		}, this.props.auth);
		console.log("Saving", sheets, data);
	}
	render(){
		const fD = this.state.firmData;
		if(Object.keys(fD).length === 0)
    {
      if(this.props.params.id)
	    {
	      this.getFirm(this.props.params.id);
	      //return <div></div>;
	    }else if(this.props.location.pathname === "/firms/new")
	    {
	    	this.getFirm("NEW");
	    }
    }
    const currSheet = fD.obsSheet ? this.state.obsSheets.find((d) => Number(d.id) === fD.obsSheet) : false;
    //console.log("hmm", fD, currSheet);
    const modules = ["RA", "Observation", "Anonym observation", "Inbox", "Værktøjer"];
		return (<Right title="Firmaer">
							{
                this.props.route.path === "/firms/new" || this.props.route.path.indexOf("/firms/edit/") !== -1 ? 
                <Panel title="Firma" key={Object.keys(fD).length ? "loaded" : "loading"}>
                	{/* <FormItem name="Farve tester" key={"QR-" + this.state.QRI}>
                		<img  ref={(elem) => {
                			setTimeout(() => {
								if(this.refs && this.refs.mainYellow)
								{
									QRCode.toDataURL(JSON.stringify({type: "TEST_COLORS", data: {"mainYellow": this.refs.mainYellow.value,"subYellow": this.refs.subYellow.value,"darkGrey": this.refs.darkGrey.value,"subGrey": this.refs.subGrey.value,"listGrey": this.refs.listGrey.value,"white": this.refs.white.value,"borderGrey": this.refs.borderGrey.value}}))
									.then(url => {
										//console.log("QR", url);
										elem.src = url;
									})
									.catch(err => {
										//console.error(err)
									});
								}
                			}, 500);
                		}}/>
                		<button onClick={() => this.setState({QRI: this.state.QRI + 1})}>Opdater QR</button>
                	</FormItem> */}
                	<form className="form-horizontal form-label-left" method="POST" action="" onChange={this.formChange} onSubmit={this.save}>
                		<div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">Navn <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="name" className="form-control col-md-7 col-xs-12" data-validate-length-range="6" data-validate-words="1" name="name" required="required" defaultValue={fD.name} type="text"/>
	                    </div>
	                  </div>
                		{/* <div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">Sprog <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="language" className="form-control col-md-7 col-xs-12" data-validate-length-range="6" data-validate-words="1" name="language" required="required" defaultValue={fD.language} type="text"/>
	                    </div>
	                  </div> */}


                		{/* <div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">MainYellow <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12 input-group colorpicker-component colorPicker">
	                      <input id="mainYellow" className="form-control" onChange={this.formChange} data-validate-length-range="6" data-validate-words="1" name="mainYellow" ref="mainYellow" required="required" style={{border: "1px solid " + fD.mainYellow}} defaultValue={fD.mainYellow} type="text"/>
										    	<span className="input-group-addon"><i></i></span>
	                    </div>
	                  </div>

                		<div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">subYellow <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="name" className="form-control col-md-7 col-xs-12 colorPicker" data-validate-length-range="6" data-validate-words="1" name="subYellow" ref="subYellow" required="required" style={{border: "1px solid " + fD.subYellow}} defaultValue={fD.subYellow} type="text"/>
	                    </div>
	                  </div>

                		<div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">darkGrey <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="name" className="form-control col-md-7 col-xs-12 colorPicker" data-validate-length-range="6" data-validate-words="1" name="darkGrey" ref="darkGrey" required="required" style={{border: "1px solid " + fD.darkGrey}} defaultValue={fD.darkGrey} type="text"/>
	                    </div>
	                  </div>

                		<div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">subGrey <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="name" className="form-control col-md-7 col-xs-12 colorPicker" data-validate-length-range="6" data-validate-words="1" name="subGrey" ref="subGrey" required="required" style={{border: "1px solid " + fD.subGrey}} defaultValue={fD.subGrey} type="text"/>
	                    </div>
	                  </div>

                		<div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">listGrey <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="name" className="form-control col-md-7 col-xs-12 colorPicker" data-validate-length-range="6" data-validate-words="1" name="listGrey" ref="listGrey" required="required" style={{border: "1px solid " + fD.listGrey}} defaultValue={fD.listGrey} type="text"/>
	                    </div>
	                  </div>

                		<div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">White <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="name" className="form-control col-md-7 col-xs-12 colorPicker" data-validate-length-range="6" data-validate-words="1" name="white" ref="white" required="required" style={{border: "1px solid " + fD.white}} defaultValue={fD.white} type="text"/>
	                    </div>
	                  </div>

                		<div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">borderGrey <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="name" className="form-control col-md-7 col-xs-12 colorPicker" data-validate-length-range="6" data-validate-words="1" name="borderGrey" ref="borderGrey" required="required" style={{border: "1px solid " + fD.borderGrey}} defaultValue={fD.borderGrey} type="text"/>
	                    </div>
	                  </div> */}

                		{/* <div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">Logo [Base64] <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="logo" className="form-control col-md-7 col-xs-12" ref={(inp) => this.b64Img = inp} data-validate-length-range="6" data-validate-words="1" name="logo" required="required" defaultValue={fD.logo} type="text"/>	                    	
	                    	<label htmlFor="64Upload">
	                    		<u>Load billede</u>
	                    	</label>
	                    	<br/>
	                    	<input type="file" id="64Upload" onChange={this.imgChange} style={{display:"none"}}/>
	                    	<img src={fD.logo} id="logoURLPreview" style={{width: "100%", marginTop: "10px"}} alt="Base64Logo"/>
	                    </div>
	                  </div> */}

                		<div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="logoURL">Logo [URL] <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="logoURL" className="form-control col-md-7 col-xs-12" data-validate-length-range="6" data-validate-words="1" name="logoUrl" required="required" defaultValue={fD.logoURL} type="text"/>
	                    	<img src={fD.logoURL} id="logoURLPreview" style={{width: "100%", marginTop: "10px"}} alt="LogoURL"/>
	                    </div>
	                  </div>

                		<div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="borderName">Mail border <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.mailBorder}} data-validate-length-range="6" data-validate-words="1" name="mailBorder" required="required" defaultValue={fD.mailBorder} type="color"/>
	                    </div>
	                  </div>
					  <h2>App farver</h2>
					  <FormItem name="Black" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.black}} data-validate-length-range="6" data-validate-words="1" name="black" required="required" defaultValue={fD.black} type="color"/>
					  </FormItem>
					  <FormItem name="Grey" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.grey}} data-validate-length-range="6" data-validate-words="1" name="grey" required="required" defaultValue={fD.grey} type="color"/>
					  </FormItem>
					  <FormItem name="Light grey" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.lightGrey}} data-validate-length-range="6" data-validate-words="1" name="lightGrey" required="required" defaultValue={fD.lightGrey} type="color"/>
					  </FormItem>
					  <FormItem name="BG grey" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.bgGrey}} data-validate-length-range="6" data-validate-words="1" name="bgGrey" required="required" defaultValue={fD.bgGrey} type="color"/>
					  </FormItem>
					  <FormItem name="Text grey" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.textGrey}} data-validate-length-range="6" data-validate-words="1" name="textGrey" required="required" defaultValue={fD.textGrey} type="color"/>
					  </FormItem>
					  <FormItem name="Orange" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.orange}} data-validate-length-range="6" data-validate-words="1" name="orange" required="required" defaultValue={fD.orange} type="color"/>
					  </FormItem>
					  <FormItem name="Dark orange" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.darkOrange}} data-validate-length-range="6" data-validate-words="1" name="darkOrange" required="required" defaultValue={fD.darkOrange} type="color"/>
					  </FormItem>
					  <FormItem name="Light orange" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.lightOrange}} data-validate-length-range="6" data-validate-words="1" name="lightOrange" required="required" defaultValue={fD.lightOrange} type="color"/>
					  </FormItem>
					  <FormItem name="Green" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.green}} data-validate-length-range="6" data-validate-words="1" name="green" required="required" defaultValue={fD.green} type="color"/>
					  </FormItem>
					  <FormItem name="Red" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.red}} data-validate-length-range="6" data-validate-words="1" name="red" required="required" defaultValue={fD.red} type="color"/>
					  </FormItem>
					  <FormItem name="Light blue" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.lightBlue}} data-validate-length-range="6" data-validate-words="1" name="lightBlue" required="required" defaultValue={fD.lightBlue} type="color"/>
					  </FormItem>
					  <FormItem name="Dark blue" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.darkBlue}} data-validate-length-range="6" data-validate-words="1" name="darkBlue" required="required" defaultValue={fD.darkBlue} type="color"/>
					  </FormItem>
					  <FormItem name="Other white" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.otherWhite}} data-validate-length-range="6" data-validate-words="1" name="otherWhite" required="required" defaultValue={fD.otherWhite} type="color"/>
					  </FormItem>
					  <FormItem name="White" required={true}>
					  	<input id="borderName" className="form-control col-md-7 col-xs-12 colorPicker" style={{border: "1px solid " + fD.white}} data-validate-length-range="6" data-validate-words="1" name="white" required="required" defaultValue={fD.white} type="color"/>
					  </FormItem>
	                  {/* <FormItem name="Moduler">
	                  	{
	                  		modules.map((d, key) => {
	                  			return (<div>
				                  					<label htmlFor={"module" + key}>{d}</label>
				                  					<input id={"module" + key} name="modules" data-i={key} type="checkbox" value={key} defaultChecked={fD.modules && fD.modules[key] ? fD.modules[key] : false}/>
				                  			</div>);
	                  		})
	                  	}
	                  </FormItem> */}
                		{/* <div className="item form-group">
	                    <label className="control-label col-md-3 col-sm-3 col-xs-12" htmlFor="name">RA Ark <span className="required">*</span>
	                    </label>
	                    <div className="col-md-6 col-sm-6 col-xs-12">
	                      <select multiple className="form-control col-md-7 col-xs-12" name="raSheet" ref={(inp) => {
	                      	window.$(".colorPicker").colorpicker();
	                      	this.raSheets = inp;
	                      }}>
	                      {
	                      	this.state.sheets.length && Object.keys(fD).length ?
			                      	this.state.sheets.map((sheeit, key) => {
			                      		return <option key={sheeit.id + sheeit.name + "sheet"} data-name={sheeit.name} data-hidden={sheeit.hidden} selected={fD.sheets.indexOf(sheeit.id) !== -1} value={sheeit.id}>[{sheeit.id}][{sheeit.hidden ? "Hidden" : "Visible"}] {sheeit.name}</option>
			                      	})
	                      	: ""
	                      }
		                      
	                      </select>
	                    </div>
	                  </div>
	                  <FormItem name="Observations ark" must={true}>
	                  	<select className="form-control col-md-7 col-xs-12" defaultValue={fD.obsSheet} ref="obsSheet">
	                      {
	                      	this.state.obsSheets.length && Object.keys(fD).length ?
			                      	this.state.obsSheets.map((sheeit, key) => {
			                      		return <option key={sheeit.id + sheeit.name + "sheet"} data-name={sheeit.name} value={sheeit.id}>[{sheeit.id}] {sheeit.name}</option>
			                      	})
	                      	: ""
	                      }
		                      
	                      </select>
	                  </FormItem>

	                  <FormItem name="Ekstra observations felter" must={false}>
	                  	 <select multiple className="form-control col-md-7 col-xs-12" ref="obsSheets" key={fD.obsSheet}>
	                      {
	                      	currSheet ?
			                      	currSheet.content.map((sheeit, key) => {
			                      		return <option key={sheeit.id} selected={fD.obsSheets.indexOf(sheeit.id) !== -1} value={sheeit.id}>[{sheeit.id}][{sheeit.type}] {sheeit.langCode}</option>
			                      	})
	                      	: ""
	                      }
		                      
	                      </select>
	                  </FormItem> */}
	                  <div className="form-group">
	                    <div className="col-md-6 col-md-offset-3">
	                      <button id="send" type="submit" className="btn btn-success">Opdater</button>
	                    </div>
	                  </div>
                	</form>
                </Panel>
                : ""
              }
							<Panel title="Oversigt" add="/firms/new" onAdd={() => this.setState({firmData: {}})}>
								<table className="table table-striped jambo_table bulk_action" id="ras">
            		<thead>
                  <tr className="headings">
                      <th className="column-title"># </th>
                      <th className="column-title">Navn </th>
                      {/* <th className="column-title">Brugere </th>
                      <th className="column-title">Rapporter </th>
                      <th className="column-title">Observationer </th>
                      <th className="column-title">Værktøjer </th> */}
                      <th className="column-title"> </th>
                  </tr>
              	</thead>
                <tbody>
                	{
                		this.state.data.map((d, key) => {
                			return (<tr key={"table_row" + key} className={key%2 ? "odd pointer" : "even pointer"}>
					                        <td className=" ">{d.id}</td>
					                        <td className=" ">{d.name}</td>
					                        {/* <td className=" ">{d.users}</td>
					                        <td className=" ">{d.ra + d.oldRa}</td>
					                        <td className=" ">{d.obs}</td>
					                        <td className=" ">{d.tools}</td> */}
					                        <td className=" ">
					                        	<Link to={"/firms/edit/" + d.id} onClick={() => this.setState({firmData: {}})}>Ret firma</Link> 
												{/* /  <Link to={"/firms"} onClick={() => {
					                        		api("POST", {"type": "fakeLogin", to: d.id}, (dat) => {
														if(!dat.error)
														{
															// console.log("Fake login". dat);
															// return;
															// const STATE = JSON.parse(localStorage.getItem(storageName));
															// STATE.data.auth = dat.token;
															// //console.log("NewState", STATE, d);
															// localStorage.setItem(storageName, JSON.stringify(STATE));
															
															store.dispatch({
																type: "UPD_AUTH",
																data: 0
															});
															document.body.className = "login";
															window.alert("Du er nu blevet flyttet! Husk at rykke tilbage når du er færdig");
														}
					                        		}, this.props.auth, 1);
					                        	}}>Flyt min bruger til hovedafdeling</Link> */}
					                        </td>
					                        
					                    </tr>);
                		})
                	}
                </tbody>
                </table>
							</Panel>
						</Right>);
	}
}

export default Firms;


// WEBPACK FOOTER //
// ./src/components/Firms.js